(() => {
  const BTN = '#cart .cart__quantity .minus, #cart .cart__quantity .plus';
  const MSG = 'Sorry, only this quantity is available in stock.';

  const sync = () => document.querySelectorAll('#cart .quantity').forEach(input => {
    const id = input.id.replace('updates_', '');
    const form = document.querySelector('.product_form[data-variant-inventory]');
    if (!form) return;

    try {
      const v = JSON.parse(form.dataset.variantInventory || '[]').find(v => String(v.id) === id);
      if (v && v.inventory_management && v.inventory_policy === 'deny') {
        input.dataset.maxQty = v.inventory_quantity;
      }
    } catch (_) {}
  });

  const notice = wrap => {
    document.querySelectorAll('.cart-qty-message').forEach(el => el.remove());
    wrap.insertAdjacentHTML('afterend', `<div class="cart-qty-message">${MSG}</div>`);
    setTimeout(() => document.querySelector('.cart-qty-message')?.remove(), 3000);
  };

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('product-form:submit:success', () => setTimeout(sync, 500));

  document.addEventListener('click', e => {
    const btn = e.target.closest(BTN);
    if (!btn) return;

    sync();

    const wrap = btn.closest('.cart__quantity');
    const input = wrap?.querySelector('.quantity');
    const qty = Math.max(1, parseInt(input?.value, 10) || 1);
    const max = parseInt(input?.dataset.maxQty, 10);
    const next = btn.classList.contains('plus') ? qty + 1 : qty - 1;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (next < 1) return (input.value = 1), false;
    if (!isNaN(max) && next > max) return notice(wrap), false;

    input.value = next;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +input.dataset.lineId, quantity: next }),
    });

    return false;
  }, true);
})();